var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-autocomplete',{attrs:{"items":_vm.currencys,"label":"Currency","item-text":"text","item-value":"value","required":"","rules":[true],"loading":_vm.gettingCurrencys},model:{value:(_vm.entity.currencyId),callback:function ($$v) {_vm.$set(_vm.entity, "currencyId", $$v)},expression:"entity.currencyId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }